import { HttpContextToken } from '@angular/common/http';

// Opt-out token for the default-on error-message interceptor; `.skipErrorMessageInterceptor()` flips it to `true`.
export const SKIP_ERROR_MESSAGE = new HttpContextToken<boolean>(() => false);
